/**
 * 公用数据存放
 *
 */
const publicData = {
	state: {
		domainUrl: '/',
		//文件上传(无凭证访问) POST
		uploadUrl: '/jbbcs/file/uploadOpenImg.do',

		//文件访问(无凭证访问) GET
		showFile: '/showFile/',

		//文件上传(访问图片时需带凭证 token) POST
		uploadUrlToken: '/jbbcs/file/uploadImg.do',

		//文件访问(需带凭证访问) GET
		showFileToken: '/jbbcs/file/getUploadFile/',
		//申请类型
		optionsApply: [
			{
				label: '请假申请',
				value: '1',
			},
			{
				label: '物品申领',
				value: '2',
			},
			// {
			// 	label: '报销申请',
			// 	value: '3',
			// },
			// {
			// 	label: '付款申请',
			// 	value: '6',
			// },
			{
				label: '资产交易付款申请',
				value: 'ZCJYFKSQ',
			},
			{
				label: '出差申请',
				value: '4',
			},
			{
				label: '加班申请',
				value: '5',
			},
			{
				label: '资金周转（内部）',
				value: '7',
			},
			// {
			// 	label: '地址费申请',
			// 	value: '8',
			// },
			// {
			// 	label: '入账申请',
			// 	value: '9',
			// },
			// {
			// 	label: '订单退款申请',
			// 	value: '10',
			// },
			// {
			// 	label: '订单补价申请',
			// 	value: 'BCJ',
			// },
			// {
			// 	label: '订单转单申请',
			// 	value: 'ZDD',
			// },
			// {
			// 	label: '预算申请',
			// 	value: 'YSSQ',
			// },
			{
				label: '纳税人资格申请',
				value: 'qyxz',
			},
			{
				label: '长期停用申请',
				value: 'tz',
			},
			{
				label: '等待启用申请',
				value: 'dqtz',
			},
			{
				label: '采购申请',
				value: 'CG',
			},
			// {
			// 	label: '备用金申请',
			// 	value: 'BYJ',
			// },
			{
				label: '借款申请',
				value: 'JK',
			},
			{
				label: '资金报备申请',
				value: 'ZJBB',
			},
			// {
			// 	label: '交接单申请',
			// 	value: 'JJD',
			// },
			// {
			// 	label: '合作商申请',
			// 	value: 'HZS',
			// },
			{
				label: '商品转移申请',
				value: 'ZY',
			},
			{
				label: '价格申请',
				value: 'JG',
			},
			// {
			// 	label: '订单复审',
			// 	value: 'DDFS',
			// },
			// {
			// 	label: '地址结算申请',
			// 	value: 'DZJS',
			// },
			{
				label: '工单申请',
				value: 'jo',
			},
			// {
			// 	label: '地址渠道修改申请',
			// 	value: 'DZQDXG',
			// },
			{
				label: '尾款备案申请',
				value: 'ZZJS',
			},
			{
				label: '公司异常申请',
				value: 'GSYC',
			},
			// {
			// 	label: '地址作废',
			// 	value: 'DZZF',
			// },
			// {
			// 	label: '僵尸单',
			// 	value: 'ZBL',
			// },
			{
				label: '企业名称修改申请',
				value: 'QYMCBG',
			},
			// {
			// 	label: '合作商付款申请',
			// 	value: '33',
			// }
		],
		//支付方式
    payWay: null,
		// payWay: [
		// 	// { label:'微信',value:'1'},
		// 	// { label:'支付宝',value:'2'},
		// 	// { label:'企业支付宝',value:'5'},
		// 	// {label:'对公',value:'6'},
		// 	// {label:'联合银行(黄功成)',value:'7'},
		// 	// {label:'联合银行(孙玉芝)',value:'8'},
		// 	// {label:'淘宝(济邦邦)',value:'9'},
		// 	{ label: '工商银行(对公银行)', value: '10' },
		// 	// {label:'企业微信',value:'11'},
		// 	{ label: '农业银行(爱华对公)', value: '12' },
		// 	// {label:'支付宝(爱华)',value:'13'},

		// 	{ label: '支付宝', value: '2' },
		// 	{ label: '企业微信', value: '11' },
		// 	{ label: '企业支付宝', value: '5' },
		// 	{ label: '对公', value: '6' },
		// 	{ label: '联合银行(黄功成)', value: '7' },
		// 	{ label: '联合银行(孙玉芝)', value: '8' },
		// 	{ label: '微信', value: '1' },
		// 	{ label: '淘宝(济邦邦)', value: '9' },
		// 	{ label: '工商银行(权驿站对公)', value: '16' },
		// 	{ label: '正潮（工行对公）', value: '19' },
		// 	{ label: '爱华微信', value: '20' },
		// 	{ label: '爱华支付宝', value: '13' },
		// 	{ label: '权驿站微信', value: '21' },
		// 	{ label: '权驿站支付宝', value: '15' },
		// 	{ label: '现金', value: '24' },
		// ],

		//支付方式
    payWayApply: null,
		// payWayApply: [
		// 	{ label: '微信', value: '1' },
		// 	{ label: '支付宝', value: '2' },
		// 	{ label: '企业支付宝', value: '5' },
		// 	{ label: '对公', value: '6' },
		// 	{ label: '联合银行(黄功成)', value: '7' },
		// 	{ label: '联合银行(孙玉芝)', value: '8' },
		// 	{ label: '淘宝(济邦邦)', value: '9' },
		// 	{ label: '工商银行(对公银行)', value: '10' },
		// 	{ label: '企业微信', value: '11' },
		// 	{ label: '农业银行(爱华对公)', value: '12' },
		// 	{ label: '爱华支付宝', value: '13' },
		// 	// {label:'权驿站微信',value:'14'},
		// 	{ label: '权驿站支付宝', value: '15' },
		// 	{ label: '工商银行(权驿站对公)', value: '16' },
		// 	{ label: '正潮（工行对公）', value: '19' },
		// 	{ label: '爱华微信', value: '20' },
		// 	// {label:'爱华支付宝',value:'23'},
		// 	{ label: '权驿站微信', value: '21' },
		// 	// {label:'权驿站企业支付宝',value:'22'},
		// 	{ label: '现金', value: '24' },
		// ],
		//未续费、停用原因
		stopReson: [
			{ label: '济邦邦注销', value: '1', },
			{ label: '客户自行注销', value: '2', },
			{ label: '聘请专职会计', value: '3', },
			{ label: '移走到其它财务公司', value: '4', },
			{ label: '转让', value: '5', },
			{ label: '失联', value: '6', },
			{ label: '无法有效沟通', value: '7', },
			{ label: '推迟支付', value: '8', },
			{ label: '其他原因', value: '9', }],
		//区域
		address: [
			{ value: '0', label: '上城区' },
			{ value: '1', label: '下城区' },
			{ value: '2', label: '拱墅区' },
			{ value: '3', label: '江干区' },
			{ value: '4', label: '西湖区' },
			{ value: '5', label: '滨江区' },
			{ value: '6', label: '余杭区' },
			{ value: '7', label: '萧山区' },
			{ value: '8', label: '富阳区' },
			{ value: '9', label: '钱塘新区' },
			{ value: '10', label: '外围区域' },
			{ value: '11', label: '零申报（一次性）' },
			{ value: '12', label: '零申报（年付）' },
			{ value: '13', label: '仅注册地址（工商我们做）' },
			{ value: '14', label: '特殊办证地址' }
		],
		//退款原因
		refundReson: [
			{ label: '客户自己原因', value: '1', },
			{ label: '会计原因', value: '2', },
			{ label: '工商原因', value: '3', },
			{ label: '销售原因', value: '4', },
			{ label: '地址原因', value: '5', },
			{ label: '政策原因', value: '6', },
			{ label: '代理商原因', value: '7', }],

		//纳税人资格  出售
		cascaderOptionsSale: [
			{
				value: "0",
				label: "小规模",
			},
			{
				value: "1",
				label: "未核税种",
			},
			{
				value: "2",
				label: "一般纳税人",
			},
		],

		//纳税人资格
		options: [
			{
				value: "0",
				label: "一般纳税人",
				children: [
					{
						value: "2",
						label: "零申报"
					},
					{
						value: "3",
						label: "非零申报"
					}
				]
			},
			{
				value: "1",
				label: "小规模纳税人",
				children: [
					{
						value: "2",
						label: "零申报"
					},
					{
						value: "3",
						label: "非零申报"
					}
				]
			}
		],


		//企查查行业分类
		sbHtType: [
			'不限',
			"01-化学原料",
			"02-颜料油漆",
			"03-日化用品",
			"04-燃料油脂",
			"05-医药用品",
			"06-金属材料",
			"07-机械设备",
			"08-手工器械",
			"09-科学仪器",
			"10-医疗器械",
			"11-灯具空调",
			"12-运输工具",
			"13-烟火相关",
			"14-珠宝钟表",
			"15-乐器",
			"16-办公用品",
			"17-橡胶制品",
			"18-皮革皮具",
			"19-建筑材料",
			"20-家具用品",
			"21-厨房洁具",
			"22-绳网袋蓬",
			"23-纱线丝",
			"24-布料床单",
			"25-服装鞋帽",
			"26-钮扣拉链",
			"27-地毯席垫",
			"28-健身器材",
			"29-食品",
			"30-方便食品",
			"31-饲料种籽",
			"32-啤酒饮料",
			"33-酒精饮品",
			"34-烟草烟具",
			"35-广告销售",
			"36-金融物管",
			"37-建筑修理",
			"38-通讯服务",
			"39-运输贮藏",
			"40-材料加工",
			"41-教育娱乐",
			"42-网站服务",
			"43-餐饮住宿",
			"44-医疗园艺",
			"45-社会服务",
		],
		expenseTypeList: [
			{
				label: '员工福利',
				value: '1'
			},
			{
				label: '固定资产',
				value: '2'
			},
			{
				label: '办公费用',
				value: '3'
			},
			{
				label: '活动费用',
				value: '4'
			},
			{
				label: '其他',
				value: '0'
			}
		],
		OaAuditTypeList: [
			{
				label: '待审核',
				value: 'afoot'
			},
			{
				label: '审核通过',
				value: 'success'
			},
			{
				label: '审核未通过',
				value: 'fail'
			},
			{
				label: '已撤回',
				value: 'revoke'
			},
			{
				label: '跳过',
				value: 'skip'
			},
			{
				label: '未开始',
				value: 'no-start'
			},
			{
				label: '已挂起',
				value: 'stop'
			}
		],
		invoiceStatus:[
			{
				label:'已作废',
				value:'-1'
			},{
				label:'待开票',
				value:'10'
			},{
				label:'申请中',
				value:'20'
			},{
				label:'待邮寄',
				value:'25'
			},{
				label:'已开票',
				value:'30'
			},{
				label:'已驳回',
				value:'40'
			},{
				label:'已撤销',
				value:'50'
			}
		]
	},
	mutations:{
		changeData:(state,{key,data})=>{
			state[key] = data
		}
	}
}
export default publicData



// WEBPACK FOOTER //
// ./src/store/components/publicData.js